import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { Company } from "#modules/company/infra/Company.dto";
import { UpdateCompanyDto } from "#modules/company/infra/updateCompany.api";
import { useUpdateCompany } from "#modules/company/view/useUpdateCompany";
import { Icon } from "#shared/icons/Icon";
import { Grid } from "#shared/view/components/Grid";
import { Button } from "#shared/view/designSystem/Button";
import { TextInputController } from "#shared/view/designSystem/inputs/TextInputController";

export const EditCompanyInfosDetails = ({
  company,
  onSubmit,
}: {
  company: Company;
  onSubmit: () => void;
}) => {
  const formMethods = useForm<UpdateCompanyDto>({
    defaultValues: {
      name: company.name,
      address: {
        street: company.address.street,
        zipCode: company.address.zipCode,
        city: company.address.city,
      },
      siret: company.siret || undefined,
      iban: company.iban || undefined,
    },
  });

  const { handleSubmit, control } = formMethods;

  const { updateCompany } = useUpdateCompany();

  const handleOnSubmit: SubmitHandler<UpdateCompanyDto> = (formData) => {
    updateCompany(formData);
    onSubmit();
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <Grid gap="lg" mt="sm">
          <Grid.Col span={4}>
            <TextInputController name="name" label="Nom de l'entreprise" control={control} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInputController name="address.street" label="Adresse" control={control} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInputController name="address.zipCode" label="Code postal" control={control} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInputController name="address.city" label="Ville" control={control} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInputController name="siret" label="SIRET" control={control} />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInputController name="iban" label="IBAN" control={control} />
          </Grid.Col>
        </Grid>
        <Button variant="filled" icon={<Icon name="save" />} type="submit" mt="sm">
          Enregistrer
        </Button>
      </form>
    </FormProvider>
  );
};
